import { render, staticRenderFns } from "./MarketStatistics.vue?vue&type=template&id=2b6b8ce4&scoped=true&"
import script from "./MarketStatistics.vue?vue&type=script&lang=js&"
export * from "./MarketStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MarketStatistics.vue?vue&type=style&index=0&id=2b6b8ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b8ce4",
  null
  
)

export default component.exports